import * as React from 'react';

import { Button } from '../button';

import type { PanelToggleButtonProps } from './panel-toggle-button.types';
import { PanelToggleIcon } from './panel-toggle-icon';

/**
 * Icon-only button that toggles a layout panel open/closed. The icon — a
 * rounded square with an edge-anchored bar that grows when open and shrinks
 * when closed — is baked in and orients itself via `side`. All other Button
 * props are forwarded, and `aria-expanded` defaults to `open`.
 *
 * Tooltips and labels are the caller's concern: wrap in a `Tooltip` and pass
 * `aria-label` as needed.
 *
 * @default variant 'outline'
 * @default size 'sm'
 * @default side 'right'
 */
export const PanelToggleButton = React.forwardRef<
  HTMLButtonElement,
  PanelToggleButtonProps
>(function PanelToggleButton(
  { open, side = 'right', variant = 'outline', size = 'sm', iconClassName, ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      iconOnly
      variant={variant}
      size={size}
      aria-expanded={open}
      {...props}
    >
      <PanelToggleIcon open={open} side={side} className={iconClassName} />
    </Button>
  );
});
